<template>
	<div>
		<form>
			<v-menu
				v-model="menu2"
				:close-on-content-click="false"
				:nudge-right="40"
				transition="scale-transition"
				offset-y
				full-width
				min-width="290px"
			>
				<template v-slot:activator="{ on }">
				<v-text-field
					v-model="date"
					label="Datum"
					prepend-icon="event"
					readonly
					v-on="on"
				></v-text-field>
				</template>
				<v-date-picker
					v-model="date"
					@input="menu2 = false"
					:full-width="$vuetify.breakpoint.xsOnly"
				></v-date-picker>
			</v-menu>
		</form>
	</div>
</template>

<script>
export default {
	name: 'TicketFilter',
	data() {
		return {
			date: new Date().toISOString().substr(0, 10),
			menu: false,
			modal: false,
			menu2: false,
			licenceplate: '',
			firstName: '',
			lastName: '',
			fullWidth: false,
		}
	},
	watch: {
		date: {
			handler() {
				this.submitfilters()
			},
		},
	},
	methods: {
		submitfilters() {
			const filterdata = {
				date: this.date,
			}
			this.$emit('submit-filters', filterdata)
		},
	},
	mounted() {
		this.submitfilters()
	},
}
</script>

<style scoped>
.searchBtn {
  position: relative;
  left: 35%;
  right: 35%;
  width: 30%;
  text-align: center;
  font-size: 18px;
  display: flex;
  border: none;
  background: #999;
  /* color: #fff; */
  padding: 7px 20px;
  margin-bottom: 15px;
  cursor: pointer;
}
.searchBtn:hover {
  background: #666;
}
.v-menu {
  background: #aaa;
}
</style>